import React from "react";
import { useTheme } from "../../context/ThemeContext.jsx";
import { pillSizes } from "../../design/tokens.js";
const tones = {
  neutral: {
    dark: "bg-white/10 text-blue-100 border-white/15",
    light: "bg-slate-100 text-slate-700 border-slate-300/50"
  },
  info: {
    dark: "bg-blue-500/15 text-blue-100 border-blue-400/30",
    light: "bg-blue-100 text-blue-800 border-blue-300/50"
  },
  success: {
    dark: "bg-green-500/20 text-green-200 border-green-400/25",
    light: "bg-green-100 text-green-800 border-green-300/50"
  },
  warning: {
    dark: "bg-amber-500/20 text-amber-200 border-amber-400/25",
    light: "bg-amber-100 text-amber-800 border-amber-300/50"
  }
};
export default function PillBadge({
  label,
  title,
  ariaLabel,
  className = "",
  tone = "neutral",
  toneClassName = "",
  size = "sm",
  pulse = false,
  icon = null
}) {
    const baseTone = tones[tone] || tones.neutral;
  const resolvedTone = toneClassName || baseTone.dark;
  const sizeClasses = pillSizes[size] || pillSizes.sm;
  if (!label) return null;
  return <span role="status" title={title || label} aria-label={ariaLabel || label} className={`inline-flex items-center gap-1 rounded-full border font-medium ${resolvedTone} ${sizeClasses} ${pulse ? "animate-pulse" : ""} ${className}`.trim()}>
      {icon ? <span aria-hidden="true" className="shrink-0">{icon}</span> : null}
      {label}
    </span>;
}